var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0256 0.975037C8.34711 0.975037 5.50099 4.19907 5.95726 7.84918L6.04323 8.53693C6.16902 9.5433 5.80142 10.5485 5.05607 11.2363C3.51159 12.6615 3.08248 14.93 3.99969 16.8209L4.11165 17.0517C4.96658 18.8142 6.75333 19.9334 8.71224 19.9334H17.6181C19.3078 19.9334 20.8804 19.0701 21.7876 17.6447C23.0683 15.6324 22.7291 12.9927 20.9814 11.3696L20.9338 11.3254C20.1337 10.5824 19.7398 9.49992 19.8752 8.41646L19.9452 7.85646C20.402 4.20248 17.5529 0.975037 13.8705 0.975037H12.0256Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5993 21.8834C10.3301 21.5244 9.82081 21.4516 9.46183 21.7209C9.10284 21.9901 9.03009 22.4994 9.29933 22.8584L9.62433 23.2917C11.4118 25.675 14.9868 25.675 16.7743 23.2917L17.0993 22.8584C17.3686 22.4994 17.2958 21.9901 16.9368 21.7209C16.5778 21.4516 16.0686 21.5244 15.7993 21.8834L15.4743 22.3167C14.3368 23.8334 12.0618 23.8334 10.9243 22.3167L10.5993 21.8834Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuNotifications);
export default __webpack_public_path__ + "static/media/menu-notifications.56de30dc083d1c714dea53314d925fda.svg";
export { ForwardRef as ReactComponent };